export const environment = {
  name: 'Dev',
  production: false,
  apiBaseUrl: 'http://graph-api-dev.eba-m3vnewcb.us-east-1.elasticbeanstalk.com/admin', // API url
  googleRecaptcha: {
    enabled: false,
    siteKey: '', // Generate your application profile & (site + secret) keys at https://www.google.com/recaptcha/admin/create
  },
};
